import { render, staticRenderFns } from "./PH2ZC2.vue?vue&type=template&id=5e9799dc&scoped=true"
import script from "./PH2ZC2.vue?vue&type=script&lang=js"
export * from "./PH2ZC2.vue?vue&type=script&lang=js"
import style0 from "./PH2ZC2.vue?vue&type=style&index=0&id=5e9799dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9799dc",
  null
  
)

export default component.exports